module.exports = __webpack_public_path__ + "img/cooperative0_logo36.3c6a3af8.jpg";